import {ImmutableObject} from "../../utils/immutableObject";
import {bigToString, parseBig} from "../../utils/math-utils";
import Big from "big.js";
import {EnumCorridorColor} from "../enum/enum-corridor-color";
import {CorridorLevel} from "./corridor-level";

export class Corridor extends ImmutableObject{

  public readonly pmax?: string;
  public readonly p90?: string;
  public readonly p50p90?: string;
  public readonly p50?: string;
  public readonly p10p50?: string;
  public readonly p10?: string;
  public readonly r7090?: string;
  public readonly r5090?: string;
  public readonly r3090?: string;
  public readonly r1090?: string;
  public readonly isNeutral?: boolean;

  constructor(p90?: string, p50p90?: string, p50?: string, p10p50?: string, p10?: string, isNeutral?:boolean, r7090?: string, r5090?: string, r3090?: string, r1090?: string){
    super();
    if(!!p90){
      this.p90 = p90;
    }
    if(!!p50p90){
      this.p50p90 = p50p90;
    }
    if(!!p50){
      this.p50 = p50;
    }
    if(!!p10p50){
      this.p10p50 = p10p50;
    }
    if(!!p10){
      this.p10 = p10;
    }
    if(!!isNeutral){
      this.isNeutral = isNeutral;
    }
    if(!!r7090){
      this.r7090 = r7090;
    }
    if(!!r5090){
      this.r5090 = r5090;
    }
    if(!!r3090){
      this.r3090 = r3090;
    }
    if(!!r1090){
      this.r1090 = r1090;
    }
  }





  public addCorridor(corridor : Corridor) : Corridor {
    return corridor.copyWith({
      p90 : bigToString(parseBig(corridor.p90).plus(parseBig(this.p90))),
      p50p90 : bigToString(parseBig(corridor.p50p90).plus(parseBig(this.p50p90))),
      p50 : bigToString(parseBig(corridor.p50).plus(parseBig(this.p50))),
      p10p50 : bigToString(parseBig(corridor.p10p50).plus(parseBig(this.p10p50))),
      p10 : bigToString(parseBig(corridor.p10).plus(parseBig(this.p10))),
    })
  }

  public multiplyCorridorByShapeSurface(corridor : Corridor, shapeSurface: Big) {
    return corridor.copyWith({
      p90 : bigToString(parseBig(corridor.p90).mul(shapeSurface)),
      p50p90 : bigToString(parseBig(corridor.p50p90).mul(shapeSurface)),
      p50 : bigToString(parseBig(corridor.p50).mul(shapeSurface)),
      p10p50 : bigToString(parseBig(corridor.p10p50).mul(shapeSurface)),
      p10 : bigToString(parseBig(corridor.p10).mul(shapeSurface)),
    })
  }

  public getCorridorLevelByColor(color : EnumCorridorColor) : CorridorLevel {
    if(color === EnumCorridorColor.GREEN) {
      return new CorridorLevel("0", this.p90)
    }
    if(color === EnumCorridorColor.LIGHTGREEN) {
      return new CorridorLevel(this.p90, this.p50p90)
    }
    if(color === EnumCorridorColor.ORANGE) {
      return new CorridorLevel(this.p50p90, this.p50)
    }
    if(color === EnumCorridorColor.RED) {
      return new CorridorLevel(this.p50, this.p10p50)
    }
    if(color === EnumCorridorColor.BLACK) {
      return new CorridorLevel(this.p10p50, "0")
    }
    return null;

  }

  public isFlat(): boolean {
    return this.p90 === this.p10;
  }
}

